import { create } from 'zustand';

interface OverlayState {
  activeModalKey: string | null;
  showOverlay: (key: string) => void;
  hideOverlay: () => void;
}

export const useOverlayStore = create<OverlayState>((set) => ({
  activeModalKey: null,
  showOverlay: (key: string) => set({ activeModalKey: key }),
  hideOverlay: () => set({ activeModalKey: null }),
}));
